import React, {Component} from 'react';
import {
  Row,
  Card,
  CardBody,
  Nav, NavItem, NavLink, TabContent, TabPane, CardTitle,
} from 'reactstrap';
import ReactTable from 'react-table';
import {withTranslation} from 'react-i18next';
import {Colxx} from '../components/common/CustomBootstrap';
import {reactTableText} from '../constants/configs';
import {keyBy, mapValues, omit} from 'lodash';
import {i18nizeDate, numberWithCommas} from '../helpers/Utils';
import ReactTableTextFilter from "../components/ReactTableTextFilter";
import ReactTableSelectFilter from "../components/ReactTableSelectFilter";
import UserInfo from "../components/UserInfo";
import classnames from "classnames";
import Api from '../services/Api';

class UserGifts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      createdList: {
        data: [],
        pages: -1,
        loading: false,
      },
      givenList: {
        data: [],
        pages: -1,
        loading: false,
      }
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
  }

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  fetchCreatedList = async listState => {
    const {userId} = this.props;
    this.setState(state => ({
      ...state,
      createdList: {
        ...state.createdList,
        loading: true,
      },
    }));
    try {
      const offset = listState.page * listState.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/giftCards',
        null,
        {
          params: {
            offset,
            limit: listState.pageSize,
            creatorType: 'USER',
            creator: userId,
            ...(listState.filtered.length ? omit(mapValues(keyBy(listState.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        }
      );
      this.setState(state => ({
        ...state,
        createdList: {
          ...state.createdList,
          data: data.rows,
          pages: Math.ceil(data.count / listState.pageSize),
        },
      }));
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState(state => ({
        ...state,
        createdList: {
          ...state.createdList,
          loading: false,
        },
      }));
    }
  };

  fetchGivenList = async listState => {
    const {userId} = this.props;
    this.setState(state => ({
      ...state,
      givenList: {
        ...state.givenList,
        loading: true,
      },
    }));
    try {
      const offset = listState.page * listState.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/giftCards',
        null,
        {
          params: {
            offset,
            limit: listState.pageSize,
            user: userId,
            status: 'ACTIVATED',
            ...(listState.filtered.length ? omit(mapValues(keyBy(listState.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        }
      );
      this.setState(state => ({
        ...state,
        givenList: {
          ...state.givenList,
          data: data.rows,
          pages: Math.ceil(data.count / listState.pageSize),
        },
      }));
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState(state => ({
        ...state,
        givenList: {
          ...state.givenList,
          loading: false,
        },
      }));
    }
  };

  getCreatedColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 200,
    },
    {
      Header: t('Gift Code'),
      accessor: 'code',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 140,
    },
    {
      Header: t('Gifts'),
      accessor: 'gifts',
      Cell: props => {
        if (props.value.length > 1) {
          return (
            <ul dir="ltr">
              {props.value.map(item => (
                <li key={item.token} style={{textAlign: 'left'}}>{`${numberWithCommas(Number(item.amount))} ${item.token}`}</li>
              ))}
            </ul>
          );
        }
        return <div dir="ltr" className="text-left pr-4">{`${numberWithCommas(Number(props.value[0].amount))} ${props.value[0].token}`}</div>
      },
      width: 200,
    },
    {
      Header: t('Recipient'),
      accessor: 'recipient',
      Cell: props => {
        const {type, value} = props.value;
        return (
          <UserInfo
            onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
            label={type === "UNKNOWN_USER" ? t('Not registered user') : t('User')}
            textColor="text-success"
            type={type}
            id={value}
          />
        );
      }
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 150,
    },
    {
      Header: t('Expiration Date'),
      accessor: 'expireCriteria.time',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 150,
    },
  ];

  getGivenColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 200,
    },
    {
      Header: t('Code'),
      accessor: 'code',
      filterable: true,
      Filter: ReactTableTextFilter,
      minWidth: 140,
    },
    {
      Header: t('Gifts'),
      accessor: 'gifts',
      Cell: props => {
        if (props.value.length > 1) {
          return (
            <ul dir="ltr" style={{marginBottom: 0}}>
              {props.value.map(item => (
                <li key={item.token} style={{textAlign: 'left'}}>{`${numberWithCommas(Number(item.amount))} ${item.token}`}</li>
              ))}
            </ul>
          );
        }
        return <div dir="ltr" className="text-left pr-4">{`${numberWithCommas(Number(props.value[0].amount))} ${props.value[0].token}`}</div>
      },
      width: 200,
    },
    {
      Header: t('Creator'),
      accessor: 'creator.value',
      Cell: props => {
        return (
          <UserInfo
            textColor="text-dark"
            label={t('Admin')}
            id={props.value}
            type="ADMIN"
          />
        );
      }
    },
    {
      Header: t('Recipient'),
      accessor: 'recipient',
      Cell: props => {
        const {type, value} = props.value;
        if (type === "USER" || type === "UNKNOWN_USER") {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + value);}}
              textColor="text-success"
              label={t('User')}
              type={type}
              id={value}
            />
          );
        }
        return <span>{value || "ALL_USERS"}</span>;
      },
      minWidth: 140,
    },
    {
      Header: t('Creditor'),
      accessor: 'creditor',
      Cell: props => {
        if (props.value) {
          return (
            <UserInfo
              onClick={() => {this.props.history.push('/dashboard/users/' + props.value);}}
              textColor="text-primary"
              label={t('Creditor')}
              id={props.value}
              type="USER"
            />
          );
        }
        return null;
      },
      width: 140,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
    },
    {
      Header: t('Registration Date'),
      accessor: 'createTime',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 150,
    },
    {
      Header: t('Expiration Date'),
      accessor: 'expireCriteria.time',
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      width: 150,
    },
  ];

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'CREATED', label: t('CREATED')},
      {value: 'STARTED', label: t('STARTED')},
      {value: 'ACTIVATED', label: t('ACTIVATED')},
      {value: 'REFUNDED', label: t('REFUNDED')},
      {value: 'EXPIRED', label: t('EXPIRED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  render() {
    const {t} = this.props;
    const {activeTab, createdList, givenList} = this.state;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-5">
                {t('Gift Cards')}
              </CardTitle>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 0 })}
                    onClick={() => {this.toggle(0);}}>
                    <span className="text-one cursor-pointer">{t('Created by user')}</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {this.toggle(1);}}>
                    <span className="text-one cursor-pointer">{t('Given to user')}</span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId={0}>
                  <ReactTable
                    manual
                    ref={el => {this.table = el;}}
                    className="-highlight"
                    data={createdList.data}
                    pages={createdList.pages}
                    loading={createdList.loading}
                    sortable={false}
                    resizable={true}
                    onFetchData={this.fetchCreatedList}
                    columns={this.getCreatedColumns(t)}
                    defaultPageSize={10}
                    style={{
                      width: '100%',
                      marginTop: 15
                    }}
                    {...reactTableText}
                  />
                </TabPane>
                <TabPane tabId={1}>
                  <ReactTable
                    manual
                    ref={el => {this.table = el;}}
                    className="-highlight"
                    data={givenList.data}
                    pages={givenList.pages}
                    loading={givenList.loading}
                    sortable={false}
                    resizable={true}
                    onFetchData={this.fetchGivenList}
                    columns={this.getGivenColumns(t)}
                    defaultPageSize={10}
                    style={{
                      width: '100%',
                      marginTop: 15
                    }}
                    {...reactTableText}
                  />
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(UserGifts);
